export const PERMS = {
    READ: 'report_customer_plans.read',
    EXPORT: 'report_customer_plans.export',
}
